import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Edital } from '../models/edital-model';
import { ResultGetPaged } from 'pmv-common';
import { SituacaoEditalFilter } from '../models/situacao-edital-filter.model';
import { SituacaoEdital } from '../models/situacao-edital-model';
import { ArquivoEditalFilter } from '../models/arquivo-edital-filter.model';
import { ArquivoEdital } from '../models/edital-arquivo-model';
import { EditalConvocacaoDeficiente } from '../models/editalConvocacaoDeficiente';

@Injectable()
export class EditalService {

  constructor(private httpClient: HttpClient) { }

  GetQtdEditalHome(tpConc: number): Observable<number[]> {
    return this.httpClient.get<number[]>(`/Edital/GetQtdEditalHome/${tpConc}`);
  }

  GetByParamHome(id: number, tpConc: number): Observable<SituacaoEdital[]> {
    return this.httpClient.get<SituacaoEdital[]>(`/Edital/GetByParamHome/${id}/${tpConc}`);
  }

  GetByParamAll(page?: number, itemsPerPage?: number, filter?: SituacaoEditalFilter): Observable<ResultGetPaged<Edital>> {
    filter.pg = page;
    filter.itensPg = itemsPerPage;
    return this.httpClient.post<ResultGetPaged<Edital>>('/Edital/GetByFiltersAll', filter);
  }

  GetByFiltersArquivo(page?: number, itemsPerPage?: number, filter?: ArquivoEditalFilter): Observable<ResultGetPaged<ArquivoEdital>> {
    filter.pg = page;
    filter.itensPg = itemsPerPage;
    return this.httpClient.post<ResultGetPaged<ArquivoEdital>>('/Edital/GetByFiltersArquivo', filter);
  }

  GetByParamAllCargos(page?: number, itemsPerPage?: number, filter?: SituacaoEditalFilter): Observable<ResultGetPaged<Edital>> {
    filter.pg = page;
    filter.itensPg = itemsPerPage;
    return this.httpClient.post<ResultGetPaged<Edital>>('/Edital/GetByFiltersAllCargos', filter);
  }
  
  getAll(page?: number, itemsPerPage?: number, filter?: SituacaoEditalFilter): Observable<ResultGetPaged<Edital>> {
    filter.pg = page;
    filter.itensPg = itemsPerPage;
    return this.httpClient.post<ResultGetPaged<Edital>>('/Edital/GetByFilters', filter);
  }

  GetAllDescByText(texto?: string): Observable<string[]> {
    let url = `/Edital/GetAllDescByText`;
    if (texto) {
      url += `?texto=${texto.replace('/', '|')}`;
    }
    return this.httpClient.get<string[]>(url);
  }

  GetEditalAutoByText(texto?: string): Observable<string[]> {
    let url = `/Edital/GetEditalAutoById`;
    if (texto) {
      url += `?texto=${texto.replace('/', '|')}`;
    }
    return this.httpClient.get<string[]>(url);
  }

  GetFuncaoEditalAutoByText(texto?: string): Observable<string[]> {
    let url = `/Edital/GetFuncaoEditalAutoById`;
    if (texto) {
      url += `?texto=${texto.replace('/', '|')}`;
    }
    return this.httpClient.get<string[]>(url);
  }

  GetAnoEditalAutoById(texto?: string, ano?: string): Observable<string[]> {
    let url = `/Edital/GetAnoEditalAutoById`;
    if (texto) {
      url += `?texto=${texto.replace('/', '|')}&ano=${ano.replace('/', '|')}`;
    }
    return this.httpClient.get<string[]>(url);
  }

  GetConcursoByEditalAno(edital?: string, ano?: string): Observable<number> {
    let url = `/Edital/GetConcursoByEditalAno`;
    if (edital) {
      url += `?edital=${edital.replace('/', '|')}&ano=${ano.replace('/', '|')}`;
    }
    return this.httpClient.get<number>(url);
  }

  GetConcursoForAvaliacaoDeficiente(edital?: string, ano?: string): Observable<EditalConvocacaoDeficiente> {
    return this.httpClient.get<EditalConvocacaoDeficiente>(`/Edital/GetConcursoForAvaliacaoDeficiente/${ano}/${edital}`);
  }

  GetConcursoByEditalAnoTipo(edital?: string, ano?: string, tipo?: number): Observable<number> {
    let url = `/Edital/GetConcursoByEditalAnoTipo`;
    if (edital) {
      url += `?edital=${edital.replace('/', '|')}&ano=${ano.replace('/', '|')}&tipo=${tipo}`;
    }
    return this.httpClient.get<number>(url);
  }

  GetCargoAnoEditalAutoById(texto?: string, ano?: string, edital?: string): Observable<string[]> {
    let url = `/Edital/GetCargoAnoEditalAutoById`;
    if (texto) {
      url += `?texto=${texto.replace('/', '|')}&ano=${ano.replace('/', '|')}&edital=${edital.replace('/', '|')}`;
    }
    return this.httpClient.get<string[]>(url);
  }

  GetCargaHorariaCargoAnoEditalAutoById(texto?: string, cargo?: string, ano?: string, edital?: string): Observable<string[]> {
    let url = `/Edital/GetCargaHorariaCargoAnoEditalAutoById`;
    if (texto) {
      url += `?texto=${texto.replace('/', '|')}&cargo=${cargo.replace('/', '|')}&ano=${ano.replace('/', '|')}&edital=${edital.replace('/', '|')}`;
    }
    return this.httpClient.get<string[]>(url);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/edital.service.ts